import {IStores} from "../types/IStores";

export class BaseStore {

    constructor(protected stores: IStores) {
    }

}